import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PromoGamer } from 'src/app/interfaces/promo-gamer';
import { LocationService } from 'src/app/services/api/location/location.service';
import { PromoGamerService } from 'src/app/services/api/promo-gamer/promo-gamer.service';

@Component({
  selector: 'app-promo-gamer',
  templateUrl: './promo-gamer.component.html',
  styleUrls: ['./promo-gamer.component.scss'],
})
export class PromoGamerComponent implements OnInit {

  constructor(
    private locationDataService: LocationService, 
    private route: ActivatedRoute,
    private promoGamerService: PromoGamerService,
  ) { 
    this.imageSrc = window.innerWidth >= this.breakpoint ? this.desktopBanner : this.mobileBanner
  }


  provinceList: string[] = [];
  selectedProvince: string | null = null;

  cityList: string[] = [];
  selectedCity: string | null = null;
  private previousProvince: string | null = null;
  private previousCity: string | null = null;

  code: string = '';

  currentLat: string = '';
  currentLng: string = '';

  cards: PromoGamer[] = [];
  isLoading: boolean = false;

  desktopBanner = '../../../assets/images/banner/banner-promo-gamer-desktop.png';
  mobileBanner = '../../../assets/images/banner/banner-promo-gamer-mobile.jpg';
  breakpoint = 768;
  imageSrc: string;


  async ngOnInit() {
    this.getRouteParam();
    await this.getCurrentPosition();
    this.loadProvinces();    
    this.getData();
    this.setImageBasedOnWidth(window.innerWidth);
  }

  private getRouteParam() {
    this.code = this.route.snapshot.paramMap.get('name')!;
  }

  private async getCurrentPosition(): Promise<void> {
    try {
      const position: any = await this.locationDataService.currentPosition();
      this.currentLat = position.lat;
      this.currentLng = position.lng;
    } catch (error) {
      this.currentLat = '';
      this.currentLng = '';
    }
  }
  

  private loadProvinces() {
    this.provinceList = this.locationDataService.getProvinces();
  }

  onProvinceSelected(province: string) {
    if (this.previousProvince !== province) {
      this.previousProvince = province;
      this.selectedProvince = province;
      this.cityList = this.locationDataService.getCities(province);
      this.selectedCity = null;
      this.getData();
    }
  }

  onCitySelected(city: string) {
    if (this.previousCity !== city) {
      this.previousCity = city;
      this.selectedCity = city;
      this.getData();
    }
  }


  private getData() {
    this.isLoading = true;

    const city = this.selectedCity === 'TODAS' ? null : this.selectedCity;
    const province = this.selectedProvince === 'TODAS' ? null : this.selectedProvince;

    const request$ = this.promoGamerService.getPromoGamer(this.code, city, province, this.currentLat, this.currentLng);

    request$.subscribe({
      next: (res: any) => {
        this.cards = res;
        this.isLoading = false;
      },
      error: (err) => {
        this.cards = [];
        this.isLoading = false;
      }
    });
  }


  openGoogleMapsDirections(lat: string, lng: string) {
    if ((this.currentLat && this.currentLng) || (lat && lng)) {
      const url = `https://www.google.com/maps/dir/?api=1&origin=${this.currentLat},${this.currentLng}&destination=${lat},${lng}`;
      window.open(url, '_blank');
    } else {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank');
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setImageBasedOnWidth(event.target.innerWidth);
  }

  private setImageBasedOnWidth(width: number) {
    if (width >= this.breakpoint) {
      this.imageSrc = this.desktopBanner;
    } else {
      this.imageSrc = this.mobileBanner;
    }
  }
}